import {Button, Container, Divider, Grid, Link, Stack, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {useUserDataContext, useUserLoginContext} from "../Contexts/UserContext";
import {useSiteDataContext} from "../Contexts/SiteDataContext";
import {useBasketContext} from "../Contexts/BasketContext";

function LoginPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const user = useUserDataContext();
    const basket = useBasketContext();
    const [isInternal] = useState(user?.internal);
    // trash the basket
    useEffect(()=> {
        basket.setSubscription(null);
        basket.setCustomer(null);
        basket.setPaymentIntent(null);
        setUser(null);
    },[]);
    const text = useSiteDataContext();
    const page = text.pages.complete;
    const siteData = useSiteDataContext();
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{page.title}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography typography="p">
                    {page.content}
                </Typography>
                <Button color="secondary" onClick={()=>{
                    if(isInternal) {
                        navigate('/internal');
                    } else {
                        window.location.href = siteData?.siteData?.siteUrl??'/';
                    }
                }} fullWidth={true} sx={(theme)=>({marginTop:theme.spacing(2)})} variant="contained" size="large">{page.button}</Button>
            </Grid>
        </Grid>
    </Container>);
}
export default LoginPage;